import { FaLaptopCode } from 'react-icons/fa';
import './logo.css';

const Logo = () => {
  return (
    <a href='#home' className='logo'>
      <FaLaptopCode />
      <span>coding gym</span>
    </a>
  );
};

export default Logo;
